var React = require('react');

function ArrowRightLight (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M34.829 0L32.2576 2.57812L39.0023 9.15234H0V12.8477H39.0023L32.2576 19.4219L34.829 22L46 11L34.829 0Z","fill":"white"}));
}

ArrowRightLight.defaultProps = {"width":"46","height":"22","viewBox":"0 0 46 22","fill":"none"};

module.exports = ArrowRightLight;

ArrowRightLight.default = ArrowRightLight;
